export default "__VITE_ASSET__ZoS1zIkN__"